export const ENTER_PRESSED = 'enter-pressed';
export const TEXTBOX_CHANGE = 'textbox-change';
export const SEARCH_BY_SPECIALTY_PROCEDURE = 'search-by-specialty-procedure';
export const OPEN_PROFILE = 'open-profile';
export const RESULT_FETCHED = 'result-fetched';
